import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroBadges, heroImage, stats } from '../data/copy';
import { HERO_SIZES, HERO_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/image';
export function Hero() {
  return <header className="w-full bg-paper" data-id="element-109" data-mp="4m8lmajdinjv">
      {/* Prima schermata compatta: frase iniziale subito in alto e CTA
          visibile senza scorrere. */}
      <div className="mx-auto max-w-5xl px-5 pb-8 pt-3 text-center sm:px-6 sm:pt-5" data-id="element-110" data-mp="127ef5fynvtei">
        <Pill tone="pine" data-id="element-111" data-mp="xaxityhb68qc">Per allenatori di pallamano</Pill>

        <h1 className="mx-auto mt-3 max-w-4xl font-display text-[2.3rem] font-bold uppercase leading-[1] tracking-tight text-pine sm:text-6xl lg:text-[4.25rem]" style={{
        fontSize: "28px"
      }} data-id="element-112" data-mp="sai4b3laiv6s">
          Pianifica il tuo allenamento di pallamano in{' '}
          <span className="text-ember" data-id="element-113" data-mp="3czfk1vt6u14g">5 minuti</span>
        </h1>

        {/* Il mockup va subito sotto la promessa. */}
        <div className="relative mx-auto mt-3 w-full max-w-[270px] sm:max-w-[360px] lg:max-w-[420px]" data-id="element-114" data-mp="3j8iw0w4jiat4">
          <div className="absolute inset-x-0 bottom-4 top-8 rounded-[2rem] bg-paper-deep" aria-hidden="true" data-id="element-115" data-mp="3o7c1c19oavi7" />
          <img src={optimizedImage(heroImage, 960)} srcSet={optimizedSrcSet(heroImage, HERO_WIDTHS)} sizes={HERO_SIZES} alt="PALLAMANO 360™ completo: 6 volumi tecnici, 72 sessioni da 60 minuti, piano della sessione su tablet e 5 bonus operativi." className="relative mx-auto w-full" width={1240} height={1240} decoding="sync" loading="eager" {...{
          fetchpriority: 'high'
        }} data-id="element-116" data-mp="39aupza1hhgvn" />
        </div>

        <p className="mx-auto mt-3 max-w-prose font-sans text-base leading-relaxed text-ink-muted" style={{
        fontSize: "14px"
      }} data-id="element-117" data-mp="2qkmrj58qbels">
          Il sistema digitale visuale per allenatori di pallamano: tecnica passo
          dopo passo, esercizi illustrati, progressioni, schemi di campo, errori
          e correzioni e allenamenti già organizzati.
        </p>

        <div className="mt-4" data-id="element-118" data-mp="2lml9mnn1hlbw">
          <CtaButton href="#oferta" size="large" className="w-full sm:w-auto" data-id="element-119" data-mp="s2jn3wuh80ji">
            Accedi al sistema completo ora
          </CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-1.5" data-id="element-120" data-mp="n98bzjimsxls">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-xs font-medium text-ink-muted sm:text-sm" data-id="element-121" data-mp="ia5kl1vkqpwa">
              <CheckIcon className="h-4 w-4 text-pine" strokeWidth={2.8} aria-hidden="true" data-id="element-122" data-mp="1b0nk5sx3a94y" />
              {badge}
            </li>)}
        </ul>
      </div>

      <div className="bg-pine" data-id="element-123" data-mp="162cd1py6icqf">
        <dl className="mx-auto grid max-w-5xl grid-cols-3 divide-x divide-paper-soft/15 px-6" data-id="element-124" data-mp="112pwp7n20gde">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse px-2 py-8 text-center" data-id="element-125" data-mp="x1ec5gj1elc2">
              <dt className="mt-2 font-display text-[11px] font-medium uppercase tracking-[0.14em] text-pine-light sm:text-sm" data-id="element-126" data-mp="3lsp2bagmmdcu">
                {stat.label}
              </dt>
              <dd className="font-display text-5xl font-bold leading-none text-paper-soft sm:text-6xl" data-id="element-127" data-mp="3htg5txu7c1dl">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}